// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._13Gg{padding:2.4rem 0}._3om9{margin-top:3rem}.pcYl{font-size:2.2rem}._5J5g{display:flex;align-items:center}._1Fvv{margin-right:1rem}._3fFB{margin:.8rem 0}html[dir=rtl] ._1Fvv{margin-right:0;margin-left:1rem}", ""]);
// Exports
exports.locals = {
	"wrapper": "_13Gg",
	"languages": "_3om9",
	"text": "pcYl",
	"link": "_5J5g",
	"flag": "_1Fvv",
	"item": "_3fFB"
};
module.exports = exports;
